/**
 * The SabineChatSession source a chat about each kind of record is saved
 * under, keyed by the shared thread's contextType: a result page's coach and
 * a readout's under RESULT_COACH, a transcript's under TRANSCRIPT_COACH. The
 * share seeds a copy from that saved thread (lib/ai-chat-subject.js) and the
 * chat library files the copy beside it (lib/chat-library/service.js); both
 * read this one table, so they cannot disagree on where a thread lives.
 */
const SESSION_SOURCE_BY_RECORD_KIND = {
  SIMULATION_RESULT: "RESULT_COACH",
  COG_REPORT: "RESULT_COACH",
  TRANSCRIPT_RESULT: "TRANSCRIPT_COACH",
  PLAYBOOK: "PLAYBOOK",
  REPORTS_CHAT: "REPORTS",
};

/** @returns {string|null} null for a kind no chat is saved under */
export function getSabineSessionSource(kind) {
  return SESSION_SOURCE_BY_RECORD_KIND[String(kind || "").toUpperCase()] || null;
}
